import { render, staticRenderFns } from "./communication-web-10-raisons-de-choisir-lagence-aleo.vue?vue&type=template&id=4ca5651c&"
import script from "./communication-web-10-raisons-de-choisir-lagence-aleo.vue?vue&type=script&lang=js&"
export * from "./communication-web-10-raisons-de-choisir-lagence-aleo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports